import React from 'react';
import { apiCreateDocument, apiUploadFile } from '../api';

/**
 * Items is the files that are uploaded to the server but not yet created in the database.
 * @param {Array} items
 */
export const useCreateDocument = () => {
  const [creating, setCreating] = React.useState(false);

  const createDocument = async (items) => {
    setCreating(true);
    const documents = Array.isArray(items) ? items : [items];
    const params = {
      documentLists: documents.map((filItem) => {
        return {
          fileSize: filItem.fileSize,
          filePath: filItem.filePath,
          fileName: filItem.rawFileName,
          mineType: filItem.mineType,
        };
      }),
    };
    try {
      const { data: createdDocument } = await apiCreateDocument(params);
      return createdDocument.data;
    } catch (error) {
      setCreating(false);
      throw error;
    }
  };

  return {
    creating,
    createDocument,
  };
};

const useUploadFile = () => {
  const [uploadedFiles] = React.useState([]);
  // const [mutate, result] = useUploadFileMutation();
  // const [mutateDocuments] = useCreateDocumentMutation();

  const upload = async (file, path) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const { data: response } = await apiUploadFile(formData);
      if (!response) {
        const error = {
          name: 'FILE_SIZE_LIMIT',
          message: 'The File Size Limit Exceeded',
        };
        throw error;
      }
      const { data } = response;
      const documents = Array.isArray(data) ? data : [data];
      const params = {
        documentLists: documents.map((uploaded) => {
          return {
            fileSize: file.size,
            filePath: path,
            fileName: uploaded.name.split('/')[1],
            mineType: uploaded.mineType,
          };
        }),
      };
      const { data: createdDocument } = await apiCreateDocument(params);
      return {
        ...createdDocument.data[0],
        url: data[0].url,
      };
    } catch (error) {
      if (error && error.name === 'FILE_SIZE_LIMIT') {
        throw error;
      }
      throw new Error('Uploaded Failed');
    }
  };

  const uploadFile = async (file, path) => {
    try {
      const willUploaded = Array.isArray(file) ? file : [file];
      const result = await willUploaded.reduce(async (acc, current) => {
        const result = await acc;
        const document = await upload(current, path);
        result.push(document);
        return Promise.resolve(result);
      }, Promise.resolve([]));
      return result;
    } catch (error) {
      throw error;
    }
  };

  return {
    uploadFile,
    uploadedFiles,
    // ...result,
  };
};

export default useUploadFile;
